import type {
  OptionAttributeValueDto,
  OptionDto,
} from "../../domain/types/company/company-product-system";

/**
 * 옵션 값 단가 계산
 *
 * 백엔드 PriceTierCalculator, 쇼핑몰 detail_new.js의 배지 갱신과 같은 규칙을 쓴다.
 * 관리자 미리보기에서만 다른 금액이 보이면 옵션 설정을 검증할 수 없기 때문이다.
 */

/**
 * 수량 구간을 고를 때 기준으로 삼을 수량.
 *
 * 미리보기에는 옵션별 수량 입력이 없어 옵션 수량을 1로 본다.
 * 그래서 SELECTABLE을 뺀 나머지는 모두 상품 주문 수량이 기준이 된다.
 * (SINGLE도 상품 주문 수량을 쓴다 — 백엔드 resolveQuantityTierBasis와 같은 규칙)
 */
export const resolveTierQuantity = (option: OptionDto, productQuantity: number): number =>
  option.quantityType === "SELECTABLE" ? 1 : productQuantity;

/**
 * 수량에 해당하는 옵션 값의 단가.
 *
 * 책등 두께 구간에 매달린 구간은 세네카(책등 두께)를 알아야 판정할 수 있어 서버 계산에 맡기고,
 * 여기서는 고정 단가 기준 구간만 본다. 어느 구간에도 못 미치면 기본 금액을 쓴다.
 */
export const resolveValueUnitPrice = (
  value: OptionAttributeValueDto,
  quantity: number,
): number => {
  const flatTiers = (value.quantityPriceTiers || []).filter(
    (tier) => tier.maxSpineThickness === null || tier.maxSpineThickness === undefined,
  );

  const picked = flatTiers
    .filter((tier) => tier.minQuantity <= quantity)
    .reduce<{ minQuantity: number; price: number } | null>(
      (best, tier) => (best === null || tier.minQuantity > best.minQuantity ? tier : best),
      null,
    );

  return picked ? picked.price : value.price ?? 0;
};
